import React from 'react';
import { SCHEMA_TYPE_MULTI_ENUM, SCHEMA_TYPE_TEXT, SCHEMA_TYPE_YOUTUBE } from '../../util/types';
import {
  isFieldForCategory,
  pickCategoryFields,
  pickCustomFieldProps,
} from '../../util/fieldHelpers.js';
import SectionDetailsMaybe from './SectionDetailsMaybe';
import SectionMultiEnumMaybe from './SectionMultiEnumMaybe';
import SectionTextMaybe from './SectionTextMaybe';
import SectionYoutubeVideoMaybe from './SectionYoutubeVideoMaybe';

const CustomListingFields = props => {
  const { publicData, metadata, listingFieldConfigs, categoryConfiguration } = props;
  const { key: categoryPrefix, categories: listingCategoriesConfig } = categoryConfiguration;
  const categoriesObj = pickCategoryFields(publicData, categoryPrefix, 1, listingCategoriesConfig);
  const currentCategories = Object.values(categoriesObj);

  const isFieldForSelectedCategories = fieldConfig => {
    return isFieldForCategory(currentCategories, fieldConfig);
  };

  const propsForCustomFields =
    pickCustomFieldProps(
      publicData,
      metadata,
      listingFieldConfigs,
      'listingType',
      isFieldForSelectedCategories
    ) || [];

  // Aggregate all options with isSelected flag and deduplicate by key
  const allOptionsWithSelection = propsForCustomFields.reduce((acc, item) => {
    if (item.schemaType !== SCHEMA_TYPE_MULTI_ENUM) return acc;
    const selectedWithDetails = item.options.map(option => ({
      key: option.key,
      label: option.label,
      isSelected: item.selectedOptions.includes(option.key),
    }));
    return acc.concat(selectedWithDetails);
  }, []);

  // Deduplicate options by key, keeping the first occurrence
  const uniqueOptions = Array.from(
    new Map(allOptionsWithSelection.map(option => [option.key, option])).values()
  );

  // Aggregate selected option keys
  const selectedOptions = uniqueOptions.filter(option => option.isSelected).map(option => option.key);

  return (
    <>
      <SectionDetailsMaybe {...props} isFieldForCategory={isFieldForSelectedCategories} />
      {propsForCustomFields.some(field => field.schemaType === SCHEMA_TYPE_MULTI_ENUM) && (
        <SectionMultiEnumMaybe
          heading="Amenities"
          options={uniqueOptions}
          selectedOptions={selectedOptions}
          showUnselectedOptions={propsForCustomFields.some(field => field.showUnselectedOptions)}
          propsForCustomFields={propsForCustomFields}
        />
      )}
      {propsForCustomFields.map(customFieldProps => {
        const { schemaType, key, ...fieldProps } = customFieldProps;
        return schemaType === SCHEMA_TYPE_TEXT ? (
          <SectionTextMaybe key={key} {...fieldProps} />
        ) : schemaType === SCHEMA_TYPE_YOUTUBE ? (
          <SectionYoutubeVideoMaybe key={key} {...fieldProps} />
        ) : null;
      })}
    </>
  );
};

export default CustomListingFields;